// extracted by mini-css-extract-plugin
module.exports = {"addItem":"ParticipantSettings_addItem_3pEm6","spinAround":"ParticipantSettings_spinAround_2nQbV"};